<template>
    <div class="seller-picker" :class="{'notAllowed': isDisabled}">
         <multiselect
            :class="[size, {'pointer': !isDisabled}]"
            v-model="selectedSeller"
            :options="getFinalSellers"
            :allowEmpty="allowEmpty"
            :multiple="false"
            :group-values="getGroupValues"
            :showLabels="false"
            :group-label="getGroupLabel"
            :placeholder="placeholder"
            track-by="id"
            :disabled="isDisabled"
            :label="getLabel"
            @input="update"
            @remove="remove"
            :openDirection="openDirection"
        >
            <span slot="noResult">No results.</span>
                <!-- Selected option -->
                <template slot="singleLabel" slot-scope="props">
                    <div class="option__desc d-flex flex-row align-items-center">
                        <span class="flexGrow1">{{ props.option.label || props.option.brandName || props.option.name}}</span>
                    </div>
                </template>

                <!-- Option on list -->
                <template slot="option" slot-scope="props">
                    <div class="option__desc d-flex flex-row align-items-center">
                        <span class="flexGrow1">{{ props.option.label ? props.option.label : props.option.brandName ? props.option.brandName : props.option.$groupLabel }}</span>
                    </div>
                </template>
        </multiselect>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'

    import Multiselect from 'vue-multiselect'
    import 'vue-multiselect/dist/vue-multiselect.min.css'

    export default {
        data() {
            return {
                selectedOption: null,
            }
        },
        props: {
            optionsType: {
                type: String,
                default: 'old'
            },
            size: {
                type: String,
                default: 'big'
            },
            openDirection: {
                type: String,
                default: 'bottom'
            },
            reservation: {
                // this is not mandatory, this component can be used without a reservation
                // for that just use the @input event to get the selected seller
                // if a reservation is provided the component will update the that reservation
                default: null
            },
            hideAllByChannel: {
                default: false,
                type: Boolean
            },
            disabled: {
                type: Boolean,
                default: false
            },
            orignalSeller: {
                default: null
            },
            agentList: {
                default: null
            },
            myTeamList: {
                default: null
            },
            inlcudeWidget: {
                default: false
            },
            hideGetYourGuide: {
                default: false
            }, 
            hideViator: {
                default: false
            },
            allowEmpty: {
                type: Boolean,
                default: false,
            },
            showMyTeam: {
                type: Boolean,
                default: true
            },
            changeReservationSeller: {
                type: Boolean,
                default: true
            },
            placeholder: {
                type: String,
                default: 'Select one'
            },
            hideOthers: {
                type: Boolean,
                default: false
            }
        },
        async created() {
            if (this.optionsType === 'new') {
                await this.downloadSellers();
            } else {
                if (this.showMyTeam) await this.downloadTeam();

                await this.downloadAgents();
            }
        },
        computed: {
            ...mapGetters([
                'account',
                'getSellers',
                'getIsLoadingSellers',
                'getTeam',
                'getAgents',
                'getActiveIntegrations',
                'getSalesChannels',
                'getIsDownloadingTeam',
                'getIsLoadingAssociatedAgent'
            ]),
            isDisabled() {
                return this.disabled || this.getIsLoadingSellers || this.getIsLoadingAssociatedAgent || this.getIsDownloadingTeam;
            },
            getGroupValues() {
                return this.optionsType === 'new' ? 'sellers' : 'people';
            },
            getGroupLabel() {
                return this.optionsType === 'new' ? 'category' : 'groupName';
            },
            getLabel() {
                return this.optionsType === 'new' ? 'label' : 'brandName';
            },
            getFinalSellers() {
                return this.optionsType === 'new' ? this.getSellers : this.options2;
            },
            selectedSeller: {
                // Getter
                get() {
                    if (this.selectedOption) {
                        return this.selectedOption;
                    } else if(this.orignalSeller) {
                        let output = this.orignalSeller;

                        return output;
                    } else {
                        return '';
                    }
                },
                // Setter
                set(newValue) {
                    this.selectedOption = newValue;
                }
            },
            allAgents() {
                let output;

                if (this.agentList) {
                    output = this.agentList;
                } else {
                    output = this.getAgents;
                }

                return output.filter(agent => {return !agent.isOTA});
            },
            options2() {
                let outputArr = [];

                // All Sellers Arr
                let allSellers = [{
                        brandName: 'All Sellers',
                        value: 0,
                        isAllSellers: true
                }];

                // All Sellers
                if (this.allowEmpty) {
                    outputArr.push({
                        groupName: 'All Sellers',
                        people: allSellers
                    });
                }

                if (this.hideAllByChannel === false ) {
                    // Add options to "All (by channel)" Arr
                    let allByChannel = []
                    if (this.getSalesChannels.length > 0) {
                        // Add "Agents"
                        allByChannel.push(this.getSalesChannels.find(channel => channel.channelType == 50));
                        // Add "My Team"
                        allByChannel.push(this.getSalesChannels.find(channel => channel.channelType == 0));
                        // All (by channel)
                        outputArr.push({
                            groupName: 'All (by channel)',
                            people: allByChannel
                        });
                    }
                }

                //** Show My Team at options */
                if (this.showMyTeam) {
                    let myTeamPeople;
                    if (this.myTeamList) {
                        myTeamPeople = this.myTeamList;
                    } else {
                        let teamArr = JSON.parse(JSON.stringify(this.getTeam));
                        
                        teamArr.map(teamMember => {
                            teamMember.brandName = teamMember.name;
                        });

                        myTeamPeople = teamArr;
                    }
                    
                    // create a group for each custom sales channel 
                    for (let person of myTeamPeople) {
                        // find if group exists
                        var groupFound = outputArr.find(outputGroup => {return outputGroup.groupName == person.salesChannel.brandName});
                        
                        if (groupFound == undefined) {
                            // createGroup
                            outputArr.push({
                                groupName: person.salesChannel.brandName,
                                people: [person]
                            });
                        } else {
                            groupFound.people.push(person);
                        }
                    }
                }

                outputArr.push({
                    groupName: 'Agents',
                    people: this.allAgents
                });

                let otherSellers = [];
                if (this.hideOthers == false && this.getSalesChannels.length > 0) {
                    // Add "Booking Widget"
                    if (this.inlcudeWidget) {
                        otherSellers.push(this.getSalesChannels.find(channel => channel.channelType == 101));
                    }

                    // Add GetYourGuide
                    if (this.hideGetYourGuide == false) {
                        // Have integration with Get Your Guide?
                        if (this.getActiveIntegrations.getYourGuide) {
                            // Add "Get Your Guide"
                            otherSellers.push(this.getSalesChannels.find(channel => channel.channelType == 202));
                        }
                    }

                    // Add "VIATOR" (only adds if the )
                    if (this.hideViator == false) {
                        if (this.getSalesChannels.some(salesChannel => salesChannel.channelType == 203)) {
                            otherSellers.push(this.getSalesChannels.find(channel => channel.channelType == 203)); 
                        }
                    }

                    outputArr.push({
                        groupName: 'Others',
                        people: otherSellers
                    });
                }

                return outputArr;
            }
        },
        methods: {
            ...mapActions([
                'downloadSellers',
                'downloadTeam',
                'downloadAgents'
            ]),
            update(value) {
                if (value) {
                    this.$emit('input', value);
                    
                    if (this.reservation && this.changeReservationSeller) {
                        this.updateReservation(value);
                    }
                }
            },
            updateReservation(newSeller){
                if (newSeller.commission) {
                    // Is an agent
                    this.reservation.creatorAgent = newSeller;
                    this.reservation.creatorUserAccount = this.account;
                    this.reservation.creatorSupplier = null;
                } else {
                    if (newSeller.channelType == 101) {
                        // Widget
                        this.reservation.channelType = 101;
                        this.reservation.creatorAgent = null;
                        this.reservation.creatorSupplier = this.account.supplier;
                    } else {
                        // Is my team
                        this.reservation.creatorAgent = null;
                        this.reservation.creatorUserAccount = newSeller;
                        this.reservation.creatorSupplier = this.account.supplier;
                    }
                }
            },
            myTeamAddBrandName(inputArr) {
                inputArr.map(row => {
                    row.brandName = row.name;
                });

                return inputArr;
            },
            remove() {
                this.$emit('deselect');
            },
            deselectSeller() {
                this.selectedSeller = "";
            }
        },
        components: {
            Multiselect
        }
    }
</script>

<style lang="scss" scoped>
    .seller-picker {
        position: relative;
        z-index: 10;
    }
</style>



// WEBPACK FOOTER //
// SellerPicker.vue?46110e60